import React, { FC, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from "../../../../../hooks/useLang";
import { UserOutlined, SearchOutlined, BackwardFilled } from "@ant-design/icons";
import { AuthContext } from "../../../../../context/auth/auth.context";
import { useScrollToTop } from "../../../../../hooks/useScrollToTop";
import HeaderTop from './HeaderTop';
import AppImage from '../../../../../components/Image/AppImage';
import useBodyClass from "../../../../../hooks/useBodyClass";
import './Header.style.scss';

const Header: FC<any> = props => {
    useScrollToTop();
    const { setThemeWrapperClassName } = useBodyClass();
    const { t, lang, getLangUrl, getAdminLangUrl } = useLang();
    const { isAuthenticated } = useContext(AuthContext);

    useEffect(() => {
        setThemeWrapperClassName('public-theme-wrapper');
    }, []);

    return (
        <header className="header-container">
            <HeaderTop />
            <section className="homepage-hero text-white">
                <div className="container-fluid">
                    <div className="d-sm-flex align-items-sm-center pt-4 pb-3">
                        <figure className="order-sm-last text-center mb-0">
                            <AppImage imageServer='LOCAL' width="480" height="440" className="w-100 h-auto homepage-hero-image" src="banner/hero-image.png" alt="Artistic depiction of Scientists doing research in various fields where a microscope is in the center with a gene helix on top" />
                        </figure>
                        <div className="p-lg-5 hero-image-separator"></div>
                        <div className="pb-5 text-center text-sm-start order-sm-first homepage-hero-text">
                            <h2 className="h3 text-white">{t('Integrated Digital Service Delivery Platform')}</h2>
                            <p className="h5 mb-4">{t('Welcome to one-stop service delivery platform with all the digital services under the scope of the Ministry of Science & Technology (MoST) and all its affiliated organizations')}</p>
                            <Link className="btn btn-primary text-uppercase rounded-sm fw-bold" to={getLangUrl(lang, '/services')}>
                                <>
                                    <SearchOutlined className="me-2 align-middle" />
                                    {t('Find Services')}
                                </>
                            </Link>
                            {isAuthenticated === true && (
                                <Link className="ms-2 btn btn-outline-secondary border-white text-white text-uppercase" to={getAdminLangUrl(lang, '/')}>
                                    <>
                                        <UserOutlined aria-hidden="true" className="me-2" style={{ verticalAlign: 'text-bottom' }} />
                                        {t('My Dashboard')}
                                    </>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
                <div className="scroll-prompt">
                    <BackwardFilled className="scroll-prompt-icon" aria-hidden="true" />
                </div>
                <svg className="svg-separator" viewBox="0 0 1366 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M-2 0V44H1368V0C1268.46 9.4 985.761 28.2 651.238 28.2C316.716 28.2 76.3619 9.4 -2 0Z" fill="#F2F2F2" />
                </svg>
            </section>
        </header>
    );
}

export default React.memo(Header);
